module.exports = __webpack_public_path__ + "img/Fuchs.9868c434.svg";